document.addEventListener('DOMContentLoaded', () => {
    const toggleButton = document.getElementById('tools-dropdown-toggle');
    const dropdownMenu = document.getElementById('tools-dropdown-menu');

    if (toggleButton && dropdownMenu) {
        toggleButton.addEventListener('click', (event) => {
            event.stopPropagation(); // Prevent click from immediately propagating to document
            const isHidden = dropdownMenu.classList.toggle('hidden');
            toggleButton.setAttribute('aria-expanded', !isHidden);
        });

        // Close dropdown if clicked outside
        document.addEventListener('click', (event) => {
            if (!dropdownMenu.classList.contains('hidden') && !toggleButton.contains(event.target) && !dropdownMenu.contains(event.target)) {
                dropdownMenu.classList.add('hidden');
                toggleButton.setAttribute('aria-expanded', 'false');
            }
        });

        // Close dropdown with Escape key
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !dropdownMenu.classList.contains('hidden')) {
                dropdownMenu.classList.add('hidden');
                toggleButton.setAttribute('aria-expanded', 'false');
            }
        });

        // Highlight "All Tools" button if a tool page is active
        const toolLinkHrefs = [
            "/extractor/",
            "/mapper/",
            "/splitter/",
            "/updater/",
            "/merger/",
            "/findreplace/"
        ];
        const currentPath = window.location.pathname;
        let isToolPageActive = toolLinkHrefs.some(href => currentPath.startsWith(href));

        if (isToolPageActive) {
            toggleButton.classList.remove('text-gray-300', 'hover:text-white', 'hover:bg-slate-700', 'bg-slate-900');
            toggleButton.classList.add('text-emerald-500');
        } else {
            // Ensure "All Tools" button is in its default state if not a tool page
            toggleButton.classList.remove('text-white', 'bg-slate-900', 'text-emerald-500');
            toggleButton.classList.add('text-gray-300', 'hover:text-white', 'hover:bg-slate-700');
        }
    }
}); 